var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-100 w-100 relative bg-light-gray"},[_c('GmapMap',{ref:"localMap",staticClass:"bg-dark-gray w-100 h-100",attrs:{"center":{
      lat: parseFloat(_vm.development.location.lat),
      lng: parseFloat(_vm.development.location.lng)
    },"zoom":_vm.StartMapZoom,"options":_vm.map.options,"map-type-id":"roadmap"}},[_c('GmapMarker',{attrs:{"position":{
        lat: parseFloat(_vm.development.location.lat),
        lng: parseFloat(_vm.development.location.lng)
      },"clickable":true,"draggable":false,"icon":_vm.map.marker[_vm.development.brand]},on:{"click":function($event){_vm.center={
        lat: parseFloat(_vm.development.location.lat),
        lng: parseFloat(_vm.development.location.lng)
      }}}})],1),_c('Controls',{on:{"filterSelected":_vm.filterIcons,"clickZoomIn":_vm.zoomIn,"clickZoomOut":_vm.zoomOut}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }